import React, { Component } from "react";

import Constants from "../../../utils/constants";
import { round } from "../../../utils/tools";

import dayjs from "dayjs";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  logo: {
    marginBottom: "10pt",
    textAlign: "center",
  },
  companyAddress: {
    marginBottom: "10pt",
  },
  addressTable: {
    border: "none",
    borderCollapse: "collapse",
    marginBottom: "16pt",
    width: "100%",
  },
  addressCell: {
    border: "none",
    padding: "2pt 4pt",
    verticalAlign: "top",
  },
  documentTitle: {
    fontSize: "16pt",
    margin: "0 0 16pt",
    textAlign: "center",
  },
  sectionTable: {
    borderCollapse: "collapse",
    marginBottom: "16pt",
    width: "100%",
  },
  sectionHeader: {
    backgroundColor: "#afaeae",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "left",
  },
  sectionCell: {
    backgroundColor: "#eeeeee",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    verticalAlign: "top",
  },
  linesTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    marginBottom: "16pt",
    width: "100%",
  },
  columnHeader: {
    backgroundColor: "#f4c181",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "left",
    verticalAlign: "middle",
  },
  amountHeader: {
    backgroundColor: "#f4c181",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "right",
    verticalAlign: "middle",
  },
  cell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    verticalAlign: "top",
  },
  amountCell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  totalLabelCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  tvaTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    width: "100%",
  },
  tvaHeader: {
    backgroundColor: "#afaeae",
    border: "1px solid #D3D3D3",
    padding: "4pt",
    textAlign: "center",
    verticalAlign: "middle",
  },
  tvaCell: {
    border: "1px solid #D3D3D3",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
};

export default class QuittancePDF extends Component {
  addSpaces(numSpaces, str) {
    return " ".repeat(numSpaces) + str;
  }

  render() {
    const { location, quittance, reglements, avis, utilisateur } = this.props;

    const societe = utilisateur.utilisateur_societe;

    const chemin = `${Constants.mode}://${Constants.domain}:${Constants.port}/api/societe/display/${societe.societe_id}`;

    let width = 200;
    let height = 30;

    if (societe.societe_logo_width) width = societe.societe_logo_width;
    if (societe.societe_logo_height) height = societe.societe_logo_height;

    const locataire = location.location_requete.requete_locataire;
    const lot = location.location_lot;
    const facture =
      !avis && !(location.location_type_contrat === 1 || location.location_type_contrat === 2);

    const totalQuittance = quittance.quittance_ligne.reduce(
      (a, b) => a + parseFloat(b.quittance_ligne_montant),
      0
    );

    const totalReglements = reglements.reduce((a, b) => a + parseFloat(b.reglement_montant), 0);

    const resteDu = parseFloat(totalQuittance - totalReglements);

    const lignesTVA = quittance.quittance_ligne.filter(
      (ligne) => ligne.quittance_ligne_rubrique.rubrique_tva === true
    );

    const totalLignesTVA = lignesTVA.reduce((a, b) => a + parseFloat(b.quittance_ligne_montant), 0);

    const baseHT = round(parseFloat(totalLignesTVA) / 1.2, 2);
    const montantTVA = parseFloat(totalLignesTVA - baseHT);

    return (
      <div style={styles.document}>
        {/* LOGO SOCIETE */}
        <div style={styles.logo}>
          <img src={chemin} width={width} height={height} alt="" />
        </div>

        {/* ADRESSE SOCIETE */}
        <div style={styles.companyAddress}>
          <strong>{`${societe.societe_raison_sociale}`}</strong>
          <br />
          {`${societe.societe_adresse.adresse_numero} ${societe.societe_adresse.adresse_voie}`}
          <br />
          {`${societe.societe_adresse.adresse_code_postal} ${societe.societe_adresse.adresse_ville}`}
        </div>

        {/* ADRESSE LOCATAIRE */}
        <div>
          <table style={styles.addressTable}>
            <tbody>
              <tr>
                <td width="55%" style={styles.addressCell}></td>
                <td width="45%" style={styles.addressCell}>
                  <strong>
                    {`${locataire.locataire_personne.personne_qualite.qualite_libelle} ${locataire.locataire_personne.personne_nom} ${locataire.locataire_personne.personne_prenom ?? ""}`}
                  </strong>
                  <br />
                  {`${locataire?.locataire_personne?.personne_adresse?.adresse_numero ?? ""} ${locataire?.locataire_personne?.personne_adresse?.adresse_voie ?? ""}`}
                  <br />
                  {`${locataire?.locataire_personne?.personne_adresse?.adresse_code_postal ?? ""} ${locataire?.locataire_personne?.personne_adresse?.adresse_ville ?? ""}`}
                  {facture && locataire?.locataire_personne?.personne_tva_number && (
                    <>
                      <br />
                      <br />
                      TVA Client : {locataire.locataire_personne.personne_tva_number}
                    </>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* TITRE DOCUMENT */}
        <div style={styles.documentTitle}>
          <strong>
            {`${facture ? "FACTURE" : avis ? "AVIS D'ÉCHÉANCE" : "QUITTANCE"} N°${
              quittance.quittance_id
            } DU ${
              facture
                ? dayjs().format("DD/MM/YYYY")
                : dayjs(quittance.quittance_date_debut).format("DD/MM/YYYY")
            }${!facture ? ` AU ${dayjs(quittance.quittance_date_fin).format("DD/MM/YYYY")}` : ""}`}
          </strong>
        </div>


        {/* LOCATION */}
        <table style={styles.sectionTable}>
          <thead>
            <tr>
              <th style={styles.sectionHeader}>
                <strong>Location</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={styles.sectionCell}>
                {`Référence: ${lot.lot_reference}`}
                <br />
                {`Adresse:`}
                <br />
                {`${lot.lot_adresse.adresse_numero} ${lot.lot_adresse.adresse_voie}`}
                <br />
                {`${lot.lot_adresse.adresse_code_postal} ${lot.lot_adresse.adresse_ville}`}
                {facture && <br />}
                {facture && <br />}
                {`${
                  facture
                    ? `Du ${dayjs(location.location_date_debut).format("DD/MM/YYYY")} au ${dayjs(
                        location.location_date_fin
                      ).format("DD/MM/YYYY")}`
                    : ""
                }`}
              </td>
            </tr>
          </tbody>
        </table>

        {/* LIGNES QUITTANCES */}
        <table style={styles.linesTable}>
          <thead>
            <tr>
              <th width="50%" style={styles.columnHeader}>
                <strong>Libellé</strong>
              </th>
              <th width="25%" style={styles.columnHeader}></th>
              <th width="25%" style={styles.amountHeader}>
                <strong>{`Montant ${facture ? "TTC" : ""}`}</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            {quittance.quittance_ligne.map((ligne, i) => {
              return (
                <tr
                  key={i}
                  style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#eeeeee" }}
                >
                  <td width="50%" style={styles.cell}>
                    {ligne.quittance_ligne_libelle
                      ? ligne.quittance_ligne_libelle
                      : ligne.quittance_ligne_rubrique.rubrique_libelle}
                  </td>
                  <td width="25%" style={styles.cell}></td>
                  <td width="25%" style={styles.amountCell}>
                    {parseFloat(ligne.quittance_ligne_montant).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <th width="50%" style={styles.totalLabelCell}></th>
              <th width="25%" style={styles.totalLabelCell}>
                <strong>{`TOTAL ${facture ? "TTC" : "DU TERME"}:`}</strong>
              </th>
              <td width="25%" style={styles.totalAmountCell}>
                <strong>
                  {parseFloat(totalQuittance).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </strong>
              </td>
            </tr>
            {facture && (
              <tr>
                <th width="50%" style={styles.totalLabelCell}></th>
                <th width="25%" style={styles.totalLabelCell}>
                  <strong>MONTANT RÉGLÉ:</strong>
                </th>
                <td width="25%" style={styles.totalAmountCell}>
                  <strong>
                    {parseFloat(totalReglements).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </strong>
                </td>
              </tr>
            )}
            {facture && (
              <tr>
                <th width="50%" style={styles.totalLabelCell}></th>
                <th width="25%" style={styles.totalLabelCell}>
                  <strong>RESTE DU:</strong>
                </th>
                <td width="25%" style={styles.totalAmountCell}>
                  <strong>
                    {parseFloat(resteDu).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </strong>
                </td>
              </tr>
            )}
            {avis && (
              <tr>
                <th width="50%" style={styles.totalLabelCell}></th>
                <th width="25%" style={styles.totalLabelCell}>
                  <strong>ARRIÉRÉS:</strong>
                </th>
                <td width="25%" style={styles.totalAmountCell}>
                  <strong>
                    {parseFloat(totalReglements).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </strong>
                </td>
              </tr>
            )}
            {avis && (
              <tr>
                <th width="50%" style={styles.totalLabelCell}></th>
                <th width="25%" style={styles.totalLabelCell}>
                  <strong>TOTAL À REGLER:</strong>
                </th>
                <td width="25%" style={styles.totalAmountCell}>
                  <strong>
                    {parseFloat(resteDu).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })}
                  </strong>
                </td>
              </tr>
            )}
          </tfoot>
        </table>

        {/* TVA */}
        {facture && (
          <table style={styles.tvaTable}>
            <thead>
              <tr>
                <th width="33%" style={styles.tvaHeader}>
                  <strong>Base HT</strong>
                </th>
                <th width="34%" style={styles.tvaHeader}>
                  <strong>% TVA</strong>
                </th>
                <th width="33%" style={styles.tvaHeader}>
                  <strong>MT TVA</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td width="33%" style={styles.tvaCell}>
                  {parseFloat(baseHT).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </td>
                <td width="34%" style={styles.tvaCell}>20,00</td>
                <td width="33%" style={styles.tvaCell}>
                  {parseFloat(montantTVA).toLocaleString("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                  })}
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    );
  }
}
